import { useId, useMemo } from 'react';

/*
    🔥 EL NOMBRE QUE VE EL NAVEGADOR NO ES EL QUE VE EL FORMULARIO

    Chrome guarda el historial de lo tipeado por NOMBRE de campo. Si dos
    formularios distintos tienen un campo "url", lo que escribiste en uno
    te lo sugiere en el otro. El atributo autoComplete no frena eso.

    La única forma de cortarlo es que el name del DOM sea único e
    irrepetible, pero useForm identifica el campo justamente por
    event.target.name.

    Entonces: al DOM le damos un nombre aleatorio, y a los handlers les
    devolvemos un evento con el nombre real. El formulario sigue
    funcionando igual y el navegador se queda sin historial que ofrecer.
*/

/*
    Para los campos que ya reconstruyen el evento con su propio nombre:
    solo necesitan que el atributo name del DOM sea irrepetible.
*/
/*
    🔥 EL ID DEL DOM TAMBIEN TIENE QUE SER UNICO

    useForm usa el nombre del campo como id ("status", "companyId"). Si el
    mismo campo existe en un filtro y en un modal, quedan dos elementos con
    el mismo id: al tocar la etiqueta del modal el navegador enfoca el
    PRIMERO del documento —el de atras— y la pagina salta hasta arriba.

    Con esto cada instancia tiene su propio id y la etiqueta apunta al
    control que le corresponde.
*/
export const useDomFieldId = (id) => {

    const AUTO = useId().replace(/:/g, '');

    return useMemo(() => `${id ?? 'field'}_${AUTO}`, [id, AUTO]);
};

export const useDomFieldName = () => useMemo(() => `nf_${Math.random().toString(36).slice(2, 10)}`, []);

export const useFieldName = ({ id, name, onChange, onBlur, isEnabled = true }) => {

    const REAL_NAME = name ?? id;

    const DOM_NAME = useMemo(
        () => (isEnabled ? `nf_${Math.random().toString(36).slice(2, 10)}` : REAL_NAME),
        [isEnabled, REAL_NAME],
    );

    const onRebuildEvent = (event) => ({
        target: {
            name: REAL_NAME,
            value: event.target.value,
            type: event.target.type,
            checked: event.target.checked,
        },
        preventDefault: () => event.preventDefault(),
        stopPropagation: () => event.stopPropagation(),
    });

    return {
        domName: DOM_NAME,

        onChangeField: (event) => (isEnabled ? onChange?.(onRebuildEvent(event)) : onChange?.(event)),

        onBlurField: onBlur ? (event) => (isEnabled ? onBlur(onRebuildEvent(event)) : onBlur(event)) : undefined,
    };
};
